import script from "./PatientDeclarationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDeclarationForm.vue?vue&type=script&setup=true&lang=js"

import "./PatientDeclarationForm.vue?vue&type=style&index=0&id=a27d3fac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a27d3fac"]])

export default __exports__